export default () => ({
  root: {
    height: "calc(100vh - 132px)",
    overflow: "auto"
  },
  customRoot: {
    height: "calc(100vh - 182px)",
  },
  superContainer: {
    position: "relative",
    background: "#F9F9F9",
    // minHeight: `calc(${window.innerHeight}px - 64px)`,
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 1,
    flex: 1,
    // marginRight:-16,
    // marginLeft: -16

  },
  form: {
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 1,
    flex: 1,
  },
  mainContainer: {
    width: "calc(100% - 85px)",
    margin: "auto",
    background: "white",
  },
  mainHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "white",
    borderTop: "1px solid #eeeeee",
    borderBottom: "1px solid #eeeeee",
    paddingRight: 20,
  },
  actionButton: {
    display: "flex",
    justifyContent: "space-between",
    width: 172,
    height: 32
  },
  buttonStyle: {
    width: 80,
    boxShadow: "none !important"
  },
  loader: {
    height: "calc(100vh - 66px)",
    background: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loaderCustom: {
    height: "87vh",
  },
  colorPrimary: {
    color: "#26bbed"
  },
  headerRight: {
    display: "flex",
    alignItems: "center"
  },
  headerButtonStyle: {
    marginLeft: 12
  },
  divider: {
    height: 30,
    width: 1,
    background: "rgba(196, 196, 196, 1)",
    margin: "0px 12px"
  },
  emailText: {
    fontSize: 16,
    color: "rgba(51, 51, 51, 1)",
    marginTop: 2,
    marginRight: 5
  },
  btnStyle: {
    textTransform: "none"
  },
  popUpText: {
    fontSize: 16,
    lineHeight: "24px"
  },
  titleText: {
    fontWeight: 600
  },
  bottomText: {
    marginTop: 8,
    marginBottom: 4,
  },
})